// Giao dịch & hợp đồng (deal-service): kiểu DTO từ @cathouse/contracts, hằng số dùng chung FE/BE, hàm hiển thị thuần
// (phút chờ duyệt, màu đợt tới). FE không tự tính lại lịch thanh toán / phí / hoa hồng — service trả sẵn.
import { deal } from '@cathouse/contracts';
import { MIN, DAY } from '@/shared/lib';

export type DealStatus = deal.DealStatus;
export type DealTab = deal.DealTab;
export type DealRow = deal.DealRow;
export type DealList = deal.DealList;
export type DealTabCounts = deal.DealTabCounts;
export type DealsOverview = deal.DealsOverview;
export type DealDetail = deal.DealDetail;
export type DealActions = deal.DealActions;
export type DealFileView = deal.DealFileView;
export type DealPaymentView = deal.DealPaymentView;
export type ScheduleRow = deal.ScheduleRow;
export type InstallmentRowStatus = deal.InstallmentRowStatus;
export type NextInstallment = deal.NextInstallment;
export type TimelineEntryView = deal.TimelineEntryView;
export type DealSubmissionView = deal.DealSubmissionView;
export type UnitChangeView = deal.UnitChangeView;
export type ChangeDealUnitResult = deal.ChangeDealUnitResult;
export type CancelDealResult = deal.CancelDealResult;
export type DealAnnouncement = deal.DealAnnouncement;
export type DealSearchHit = deal.DealSearchHit;
export type FileAttachment = deal.FileAttachment;

export const DEAL_TABS = deal.DEAL_TABS;
/** "Hình thức" của phiếu cọc · hình thức thanh toán đợt · lý do huỷ (contracts — bên sở hữu khai báo). */
export const DEPOSIT_METHODS = deal.DEPOSIT_METHODS;
export const PAY_METHODS = deal.PAY_METHODS;
export const CANCEL_REASONS = deal.CANCEL_REASONS;
export const INSTALLMENT_ROW_STATUS_LABEL = deal.INSTALLMENT_ROW_STATUS_LABEL;

/** Nhãn tab danh sách (đúng prototype). */
export const DEAL_TAB_LABEL: Record<DealTab, string> = {
  pending: 'Chờ duyệt cọc',
  active: 'Đã cọc · chờ ký',
  contracted: 'Đã ký HĐ',
  due: 'Đến hạn thanh toán',
  completed: 'Hoàn tất',
  closed: 'Huỷ / từ chối',
  all: 'Tất cả',
};

export const DEAL_SORT_KEYS = ['createdAt', 'value', 'paid'] as const;
export type DealSortKey = (typeof DEAL_SORT_KEYS)[number];
export type SortDir = 'asc' | 'desc';

export interface DealListFilters {
  tab: DealTab;
  projectId?: string;
  q?: string;
  sort: DealSortKey;
  dir: SortDir;
}
/** Số dòng tối đa mỗi lần tải (pageSize tối đa của deal-service). */
export const DEAL_LIST_LIMIT = 200;

/** Phút chờ duyệt theo giờ máy chủ (cập nhật tại chỗ, không chờ tải lại). */
export const waitMinutes = (createdAt: string, now: number) => Math.max(0, Math.round((now - Date.parse(createdAt)) / MIN));

/** Màu hạn đợt tới: quá hạn ⇒ đỏ, trong 7 ngày ⇒ cam, còn lại chữ phụ. */
export function dueColor(due: string, now: number) {
  const t = Date.parse(due);
  return t < now ? 'var(--bad)' : t < now + 7 * DAY ? 'var(--warn)' : 'var(--fg-2)';
}

/** Giao dịch còn hiệu lực (đã cọc, đã ký HĐ, hoàn tất) — có tin báo chốt, tính doanh số. */
export const isLiveDeal = (s: DealStatus) => (deal.LIVE_DEAL_STATUSES as readonly string[]).includes(s);
